<script>
export default {
    props: {
        trimModel: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        field: {
            type: Object,
            required: true
        },
        fieldModel: {
            type: Object,
            required: true
        },
        className: {
            type: String
        },
        errorAfterBlur: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            value: null,
            blured: false,
            touched: false,
            focused: false
        }
    },
    computed: {
        activeErrors: function() {
            if (this.field.validations && this.field.validations.length > 0) {
                const filtered = this.field.validations.filter(v => {
                    if(this.fieldModel.$error && this.fieldModel[v.name] === false) {
                        return v;
                    }
                    return false;
                });

                return filtered;
            }
            return [];
        },
        isActive: function() {
            return !!this.fieldModel.$dirty || (this.fieldModel.$model && this.fieldModel.$model !== "");
        },
        showError: function() {
            let showError = this.fieldModel.$error && this.blured;
            if (!this.errorAfterBlur || !this.touched) {
                showError = this.fieldModel.$error
            }

            return showError;
        }
    },
    methods: {
        change(e) {
            let value = e.target.value;
            if (value && this.trimModel) {
                value = value.trim();
            }

            this.fieldModel.$model = value;
            this.$emit('input', value);
            this.fieldModel.$touch();
            this.touched = true;

            if (this.fieldModel.$model === value && this.trimModel) {
                this.$forceUpdate();
            }

        },
        // eslint-disable-next-line
        onBlur(e) {
            this.blured = true;
            this.focused = false;
        },
        onFocus() {
            this.focused = true;
        }
    },
    render: function (h) {
        let fieldClass = "validate ";
        let labelClass = "";

        if (this.isActive || this.focused) {
            labelClass += ' active';
        }

        if (this.showError && this.fieldModel.$dirty) {
            fieldClass += ' invalid';
        }

        let dataType = this.field.dataType;

        if (!this.field.dataType || this.field.dataType === 'string') {
            dataType = 'text';
        }

        const wrapperClass = `input-field ${this.className}`;

        return (
            <div class={wrapperClass} >

                {
                    (!this.field.options) &&
                    <input
                        ref="inputRef"
                        disabled={this.disabled}
                        id={this.field.atrName}
                        type={dataType}
                        class={fieldClass}
                        value={this.fieldModel.$model}
                        onFocus={this.onFocus}
                        onChange={this.change}
                        onInput={this.change}
                        onblur={this.onBlur}
                    />
                }


                <label
                    class={labelClass}
                    for={this.field.atrName}>
                    {this.field.title}
                </label>

                {
                    (this.showError && this.fieldModel.required === false) &&
                    <span class="error-message-container">
                        <i class="icon-info"></i>
                        <span>{this.$t('components.forms.invalid_required')}</span>
                    </span>
                }

                {
                    (this.showError && this.fieldModel.minLength === false) &&
                    <span  class="error-message-container">
                        <i class="icon-info"></i>
                        <span>{this.$tc(`components.forms.invalid_too_short`, this.fieldModel.$params.minLength.min)}</span>
                    </span>
                }

                {
                    (this.showError && this.fieldModel.maxLength === false) &&
                    <span  class="error-message-container">
                        <i class="icon-info"></i>
                        <span>{this.$tc(`components.forms.invalid_too_long`, this.fieldModel.$params.maxLength.max)}</span>
                    </span>
                }

                {
                    (this.showError && this.fieldModel.regexValidator === false) &&
                    <span class="error-message-container">
                        <i class="icon-info"></i>
                        <span>{this.$t('components.forms.invalid_format')}</span>
                    </span>
                }

                {(this.showError) &&
                    this.activeErrors.map(item => {
                        return (
                            <span class="error-message-container">
                                <i class="icon-info"></i>
                                {item.createDynamicContent && item.createDynamicContent(h)}
                                {item.errorText &&
                                    <span>
                                        {item.errorText && item.errorText}
                                    </span>
                                }
                            </span>
                        );
                    })
                }

            </div>
        )
    }
}
</script>


